import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const SSO_USER_CODE: {
  SSO_USER_NOT_FOUND: MvnCodeBE;
  SSO_USER_DISABLED: MvnCodeBE;
  SSO_USER_DESTROYED: MvnCodeBE;
} = {
  SSO_USER_NOT_FOUND: {
    status: 404,
    ko: "존재하지 않는 유저입니다.",
    en: "The requested user does not exist.",
  },
  SSO_USER_DISABLED: {
    status: 409,
    ko: "계정 정보가 유효하지 않습니다. 관리자에게 확인 바랍니다. (CODE: DI-01)",
    en: "Your account is not valid. Please contact system administrator. (CODE: DI-01)",
  },
  SSO_USER_DESTROYED: {
    status: 409,
    ko: "계정 정보가 유효하지 않습니다. 관리자에게 확인 바랍니다. (CODE: DE-02)",
    en: "Your account is not valid. Please contact system administrator. (CODE: DE-02)",
  },
};

MvnCodeInitiate(SSO_USER_CODE);
